import { useDispatch, useSelector } from "react-redux";
import { Select, Option, Button, Tooltip } from "../../../common/HarmonyEnablers";
import { getTenantDisplayLabel } from "../../../shared-components/app-personas/AppPersona.selectors.redux";
import { CosmosConnection } from "../../../model/connections/CosmosConnection.model";
import { Icon, TextField } from "../ConnectionScope";
import "../connections.css"
import { AppDispatch, RootState } from "../../../root-redux/RootState";
import { postConnections } from "../../../services/PostConnections.api";
import { ConnectionType } from "../../../model/connections/ConnectionType.model";
import { useEffect, useState } from "react";
import { TeamsList } from "../../../model/role-based-access-control/RoleBasedAcessControl.model";
import { AppPersona } from "../../../model/app-persona/AppPersona.model";
import { withErrorBoundary } from "../../../shared-components/ErrorBoundary";
import { Connection } from "../../../model/connections/Connection.model";


const CosmosConnectionPanelC: React.FC<{connectionData: CosmosConnection, editMode: boolean, appScopes: string[] | undefined, connectionType: ConnectionType, subscriptions: {key: string, name: string}[], authType:string}> = ({connectionData, editMode, appScopes, connectionType, subscriptions, authType}) => {
    const dispatch = useDispatch<AppDispatch>()
    const [data, setData] = useState<CosmosConnection>(connectionData);
    const selectedEnv =  useSelector((state: RootState) => state.env.selectedEnvItem);

    const adbScopeDev = "https://adb-5404863101054673.13.azuredatabricks.net/?o=5404863101054673#secrets/createScope";
    const adbScopUat = "https://adb-2987319840690271.11.azuredatabricks.net/?o=2987319840690271#secrets/createScope";
    const adbScopProd = "https://adb-5011763184037517.17.azuredatabricks.net/?o=5011763184037517#secrets/createScope";


    useEffect(() => {
        setData(connectionData)
    }, [connectionData])
    
    if (!connectionData && !editMode) {
        return <></>
    }

    const canEnableSave = () => {
        if (editMode) {
            if (authType == "spn" && (!data.connectionName?.trim() || !data.appScope || !data.databaseName?.trim() || !data.cosmosContainer?.trim() || !data.region?.trim() || !data.batchSize?.trim() || !data.cosmosConnectionString?.trim())) {
                return false
            }
            if (authType == "msi" && (!data.connectionName?.trim() || !data.appScope || !data.databaseName?.trim() || !data.cosmosContainer?.trim() || !data.region?.trim() || !data.batchSize?.trim())) {
                return false
            }
            if (connectionData && JSON.stringify(connectionData) === JSON.stringify(data)) {
                return false
            }
            return true
        }
        return false
    }

    const onSaveClick = () => {
        var finalData = {} as CosmosConnection extends Connection ? CosmosConnection : Connection;
        if(authType == "spn")
            finalData = {...data, useMSI: 0};
        else
        finalData = {...data, useMSI: 1, cosmosConnectionString: ''};
        dispatch(postConnections({ newConnection: finalData, type: connectionType }))
    }

    let subscriptionName = ''
    if (!editMode) {
        subscriptionName = subscriptions.filter(item => item.key === data.subscriptionKey)[0]?.name || ''
    }

    return ( 
        <>       
                <div className='input-row'>
                    <div>Name</div>
                    <div>
                        <TextField id = "cosmosname" required disabled={!editMode} placeholder="Name" value={data.connectionName || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, connectionName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Tenant</div>
                    <Select
                            value= {data.subscriptionKey || ''}
                            slot="action"
                            fixed-placement
                            disabled={!editMode}
                            placeholder={getTenantDisplayLabel(subscriptionName) || 'Select'}
                            id = "cosmostenant"
                            >
                            {
                                subscriptions?.map((item) => (
                                    <Option
                                        key={item.key}
                                        role="menuitemcheckbox"
                                        value={item.key}
                                        onHeSelected={(e: any) => {
                                            setData({...data, subscriptionKey: e.target.value})
                                            
                                        }}
                                    >
                                        {getTenantDisplayLabel(item.name)}
                                    </Option>
                                ))
                            }
                        </Select>
                    </div>
                <div className='input-row'>
                    <div>App Scope
                    <Icon id="info66" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info66" fixedPlacement={true} placement='bottom'>
                            Select the app scope. If creating, then create the app scope in all the three environments.
                            </Tooltip>
                    </div>
                    <div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <Select
                                value= {data.appScope || ''}
                                slot="action"
                                fixed-placement
                                disabled={!editMode}
                                placeholder='Select'
                                style={{width: '500px'}}
                                id = "cosmosscope"
                                >
                                {
                                    appScopes?.map(item => (
                                        <Option
                                            key={item}
                                            role="menuitemcheckbox"
                                            onHeSelected={(e: any) => {
                                                setData({...data, appScope: e.target.textContent})
                                                
                                            }}
                                        >
                                            {item}
                                        </Option>
                                    ))
                                }
                            </Select>
                            {/* TODO add this to aka.ms */}
                            {
                                selectedEnv == "dev" ? <a id="cosmosdevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a> 
                                : selectedEnv == "uat" ? <a id="cosmosuatscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopUat}>Add New Scope</a> 
                                : selectedEnv == "prod" ? <a id="cosmosprodscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopProd}>Add New Scope</a> 
                                : <a id="cosmosdevscope" style={{marginLeft: '10px'}} target="_blank" href={adbScopeDev}>Add New Scope</a>
                            }
                            <Icon id="infoaddscopecosmos" name="info" style={{ marginLeft: "4px", cursor: "pointer", color: "#0078D4" }} tabIndex={0}/>
                            <Tooltip anchor="infoaddscopecosmos" fixedPlacement={true} placement='bottom'>
                            The new scope needs to be created in all the three environments
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Database
                    <Icon id="info67" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info67" fixedPlacement={true} placement='bottom'>Select the Database name </Tooltip>
                    </div>
                    <div><TextField id = "cosmosdatabase" required disabled={!editMode} placeholder="Database" value={data.databaseName || ''} onHeInput={(e: any) => {
                            setData({...data, databaseName: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Container
                    <Icon id="info68" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info68" fixedPlacement={true} placement='bottom'>
                            Select the Container
                            </Tooltip>
                    </div>
                    <div><TextField id = "cosmoscontainer" required disabled={!editMode} placeholder="Container" value={data.cosmosContainer || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, cosmosContainer: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                <div className='input-row'>
                    <div>Region
                    <Icon id="info69" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info69" fixedPlacement={true} placement='bottom'>
                            Select the Region
                            </Tooltip>
                    </div>
                    <div><TextField id = "cosmosregion" required disabled={!editMode} placeholder="Region" value={data.region || ''} onHeInput={(e: any) => {
                        setData({...data, region: e.target.value})
                            
                    }}/>
                    </div>
                </div>                
                <div className='input-row'>
                    <div>Batch Size
                    <Icon id="info70" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info70" fixedPlacement={true} placement='bottom'>
                            Select the Batch size
                            </Tooltip>
                    </div>
                    <div><TextField id = "cosmosbatch" required disabled={!editMode} placeholder="Batch Size" value={data.batchSize || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, batchSize: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                {authType == "spn" &&
                <div className='input-row'>
                    <div>Connection String
                    <Icon id="info71" name="info" style={{ marginLeft: "7px", cursor: "pointer", color: "#0078D4" }} />
                            <Tooltip anchor="info71" fixedPlacement={true} placement='bottom'>
                            Select the Connection String
                            </Tooltip>
                    </div>
                    <div><TextField id = "cosmosconnectionstring" required disabled={!editMode} placeholder="Connection String" value={data.cosmosConnectionString || ''} 
                        onHeInput={(e: any) => {
                            setData({...data, cosmosConnectionString: e.target.value})
                            
                        }}/>
                    </div>
                </div>
                }
            <div slot="footer" className="panel-footer">
                <Button id = "cosmossave" onClick={onSaveClick} disabled={!canEnableSave()} appearance={editMode ? 'primary': undefined}>
                    Save
                </Button>
            </div>
        </>     
    )
}
export const CosmosConnectionPanel = withErrorBoundary("Cosmos Connection panel", CosmosConnectionPanelC);